import React, { useState, useEffect } from 'react';
import './ExtendedWarrantyDetails.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import axiosInstance from '../../../../../../http.common';
import Swal from 'sweetalert2';
import { showErrorAlert } from '../../../../../customComponents/CustomSweetAlert/errorsweetalert';

const ClaimWarrantyDetails = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [ yesModal, setYesModal ] = useState(false)
  const [ noModal, setNoModal ] = useState(false)

  const [remark, setRemark] = useState('');
  const [actionType, setActionType] = useState('');
  const [ExtWarrantyData, setExtWarrantyData] = useState([]);
  const [ itemReceivedVal , setItemReceivedVal  ] = useState(0)

  const [ statusVal , setStatusVal  ] = useState("")

  const location = useLocation();
  const claimWarrantyId = location?.state?.data?.claimWarrantyId;
  const Token = localStorage.getItem("authToken");

  // Fetching extended warranty details
  const fetchDepartmentEdit = async () => {
    try {
      const response = await axiosInstance.get(`warrantyclaim/approval-details/${claimWarrantyId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });
      const formatData = response.data.data[0];
      const itemReceived = formatData.isRecevedItem
      const status = formatData?.status
      setStatusVal(status)
      setItemReceivedVal(itemReceived)

      setExtWarrantyData(formatData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDepartmentEdit();
  }, []);

  // Function to handle the approval or rejection API call
  const handleApprovalAPI = async (isApproved, remark = '') => {
    try {
      const payload = {
        // claimWarrantyId,

        // isApproved,
        remark,

        status:isApproved,
    isRecevedItem:0,
    // "remark":""
      };

      const response = await axiosInstance.patch(`/warrantyclaim/update-status-arrpoval/${claimWarrantyId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });



      if (response?.status==200) {
       
        navigate(ROUTES_NAVIGATION.CLAIMWARRANTY);
      } 
    } catch (error) {
      console.error("API Error:", error);
      
    }
  };


  // const handleYess = async () => {
  //   try {
  //     const payload = {
  //       status:1,
  //       isRecevedItem:1,
  //       remark:"",
  //     };

  //     const response = await axiosInstance.patch(`/warrantyclaim/update-status-arrpoval/${claimWarrantyId}`, payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${Token}`,
  //       },
  //     });



  //     if (response?.status==200) {
       
  //       navigate(ROUTES_NAVIGATION.CLAIMWARRANTY);
  //     } 
  //   } catch (error) {
  //     console.error("API Error:", error);
      
  //   }
  // };

  // const handleNo = async () => {
  //   try {
  //     const payload = {
  //       status:1,
  //       isRecevedItem:0,
  //       remark:"",
  //     };

  //     const response = await axiosInstance.patch(`/warrantyclaim/update-status-arrpoval/${claimWarrantyId}`, payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${Token}`,
  //       },
  //     });



  //     if (response?.status==200) {
       
  //       navigate(ROUTES_NAVIGATION.CLAIMWARRANTY);
  //     } 
  //   } catch (error) {
  //     console.error("API Error:", error);
      
  //   }
  // };


  const handleYess = async () => {

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to Yes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {

    try {
      const payload = {
        status:1,
        isRecevedItem:1,
        remark:remark,
      };

      const response = await axiosInstance.patch(`/warrantyclaim/update-status-arrpoval/${claimWarrantyId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });



      if (response?.status==200) {
       
        navigate(ROUTES_NAVIGATION.CLAIMWARRANTY);
      } 
    } catch (error) {
      console.error("API Error:", error);
      const errorMessage = error.response?.data?.data?.message
      console.log(errorMessage, "errorMessage")

      showErrorAlert({
        title: "Something went wrong",
        text: errorMessage || "An error occurred while processing your request.",
        callback: () => { 
          // Optional: code to execute after confirming the alert
          console.log("Error alert confirmed");
        }
      });
    }
   
  }
  })
  if (!result.isConfirmed) {
    // setLoading(false); 
  }
  };

  const handleNo = async () => {

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to do No?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {

    try {
      const payload = {
        status:1,
        isRecevedItem:0,
        remark:remark,
      };

      const response = await axiosInstance.patch(`/warrantyclaim/update-status-arrpoval/${claimWarrantyId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });



      if (response?.status==200) {
       
        navigate(ROUTES_NAVIGATION.CLAIMWARRANTY);
      } 
    } catch (error) {
      console.error("API Error:", error);

      const errorMessage = error.response?.data?.data?.message
      console.log(errorMessage, "errorMessage")

      showErrorAlert({
        title: "Something went wrong",
        text: errorMessage || "An error occurred while processing your request.",
        callback: () => { 
          // Optional: code to execute after confirming the alert
          console.log("Error alert confirmed");
        }
      });
      
    }
   
  }
  
  })
  if (!result.isConfirmed) {
    // setLoading(false); 
  }
  };

  // Open modal for rejection
  const openRejectModal = () => {
    setActionType('Reject');
    setIsModalOpen(true);
  };


  // Handle the submit action for rejection
  const handleRejectSubmit = () => {
    handleApprovalAPI(2, remark); // Reject with remark
    closeModal();
  };

  // Approve without opening the modal
  const handleApprove = () => {
    handleApprovalAPI(1); // Approve without remark
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setRemark('');
  };


    const openYesModal = () => {
    setYesModal(true);
  };

  const closeYesModal = () => {
    setYesModal(false);
    setRemark('');
  };

  const openNoModal = () => {
    setNoModal(true);
  };

  const closeNoModal = () => {
    setNoModal(false);
    setRemark('');
  };


  return (
    <>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Warranty Claim Details</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>

        {yesModal && (
                <div className="customModalOverlay">
                    <div className="custom-modal">
                        <div className="custom-modal-header">
                            <h6 style={{fontSize:"18px"}}>Remarks</h6>
                            <button className="close-button" onClick={closeYesModal}>
                                ×
                            </button>
                        </div>
                        <div className="custom-modal-body">

<textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remark here"
              rows="4"
              className="remark-textarea"
            />
                        </div>
                        <div className="custom-modal-footer">
                            <button
                                className="btn btn-primary"
                                style={{ background: "#7BD755", color: "white", border: "none", borderRadius:"20px", padding:" 10px 28px" }}
                                onClick={handleYess}
                            >
                                Submit
                            </button>
                            <button className="btn btn-primary"  style={{ background: "white", color: "#7BD755", border: "1px solid #7BD755", borderRadius:"20px", padding:" 10px 28px" }} onClick={closeYesModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

{noModal && (
                <div className="customModalOverlay">
                    <div className="custom-modal">
                        <div className="custom-modal-header">
                            <h6 style={{fontSize:"18px"}}>Remarks</h6>
                            <button className="close-button" onClick={closeNoModal}>
                                ×
                            </button>
                        </div>
                        <div className="custom-modal-body">

<textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remark here"
              rows="4"
              className="remark-textarea"
            />
                        </div>
                        <div className="custom-modal-footer">
                            <button
                                className="btn btn-primary"
                                style={{ background: "#7BD755", color: "white", border: "none", borderRadius:"20px", padding:" 10px 28px" }}
                                onClick={handleNo}
                            >
                                Submit
                            </button>
                            <button className="btn btn-primary"  style={{ background: "white", color: "#7BD755", border: "1px solid #7BD755", borderRadius:"20px", padding:" 10px 28px" }} onClick={closeNoModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

{
  itemReceivedVal === 0 ? (
    statusVal === "Pending" ? (
      <>
        <button
          className="addcustomerbutton"
          onClick={handleApprove}
        >
          Approve
        </button>
        <button
          className="reject-button"
          onClick={openRejectModal}
        >
          Reject
        </button>
      </>
    ) : statusVal === "Approved" ? (
      <>
        {/* <div>
          <p style={{ paddingTop: "12px", fontSize: "18px", fontWeight: "600" }}>
            Is Item Recieved?
          </p>
        </div>
        <button
          className="addcustomerbutton"
          onClick={openYesModal}
        >
          Yes
        </button>
        <button
          className="reject-button"
          onClick={openNoModal}
        >
          No
        </button> */}
        
      </>
    ) : null
  ) : null
}


        </div>
      </div>

      {/* Order Details Section */}
      <h5 className="mt-2 mb-2 ">Order Details</h5>
      <div className="details-section">
       
        <div className="detail-grid">
          <div className="details-item">
            <span className="details-label">Dealer Name</span>
            <span className="details-value">{ExtWarrantyData?.dealer_name}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Vin No.</span>
            <span className="details-value">{ExtWarrantyData?.vinNum}</span>
          </div>

          <div className="details-item">
            <span className="details-label">Repair Status</span>
            <span className="details-value">{ExtWarrantyData?.repairStatus}</span>
          </div>

          <div className="details-item">
            <span className="details-label">Status</span>
            <span className="details-value">{ExtWarrantyData?.status}</span>
          </div>

          <div className="details-item">
            <span className="details-label">Claim Code</span>
            <span className="details-value">{ExtWarrantyData?.claimCode}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Claim Name</span>
            <span className="details-value">{ExtWarrantyData?.claimName}</span>
          </div>
          <div className="details-item">
            <span className="details-label">Created At</span>
            <span className="details-value">{ExtWarrantyData?.createdAt}</span>
          </div>

          <div className="details-item">
            <span className="details-label">Warranty From</span>
            <span className="details-value">{ExtWarrantyData?.warrantyFrom}</span>
          </div>

          <div className="details-item">
            <span className="details-label">Warranty To</span>
            <span className="details-value">{ExtWarrantyData?.warrantyTo}</span>
          </div>

          <div className="details-item">
            <span className="details-label">Remark</span>
            <span className="details-value">{ExtWarrantyData?.remark ?? "-"}</span>
          </div>
          
        </div>
      </div>

      {/* Modal for Rejection */}

      {isModalOpen && (
                <div className="customModalOverlay">
                    <div className="custom-modal">
                        <div className="custom-modal-header">
                            <h6 style={{fontSize:"18px"}}>Remarks</h6>
                            <button className="close-button" onClick={closeModal}>
                                ×
                            </button>
                        </div>
                        <div className="custom-modal-body">

<textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remark here"
              rows="4"
              className="remark-textarea"
            />
                        </div>
                        <div className="custom-modal-footer">
                            <button
                                className="btn btn-primary"
                                style={{ background: "#7BD7554", color: "white", border: "none", borderRadius:"20px", padding:" 10px 28px" }}
                                onClick={handleRejectSubmit}
                            >
                                Reject
                            </button>
                            <button className="btn btn-primary"  style={{ background: "white", color: "#7BD755", border: "1px solid #7BD755", borderRadius:"20px", padding:" 10px 28px" }} onClick={closeModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}


      {/* {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h5>Reject Remark</h5>
            <textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remark here"
              rows="4"
              className="remark-textarea"
            />
            <div className="modal-buttons">
              <button onClick={handleRejectSubmit} className="submit-button">
                Submit
              </button>
              <button onClick={closeModal} className="cancel-button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default ClaimWarrantyDetails;

